import {forwardRef, useCallback, useEffect, useMemo} from "react";
import {userApi} from "~/api";
import {DebounceSelect} from "../index";
import SearchUserOption from "./SearchUserOption";

const SelectUsersMultiple = forwardRef(({ options, setOptions, errors, ...props }, ref) => {

	const onSearch = useCallback(async (keyword) => {
		const response = await userApi.search({
			keyword,
			department: props?.department,
			status:     props?.status,
			onlyActive: props?.onlyActive,
		});
		return response.data.map((user) => ({
			label: <SearchUserOption item={user} />,
			value: user.id,
		}));
	}, [props]);

	const optionsDefault = useMemo(() => options, [options]);

	useEffect(() => {
		if (typeof setOptions !== "undefined") {
			setOptions(optionsDefault);
		}
	}, [optionsDefault, setOptions]);

	return (
		<DebounceSelect
			mode="multiple"
			fetchOptions={onSearch}
			errors={errors}
			optionsDefault={optionsDefault}
			{...props}
			ref={ref}
		/>
	);
});

export default SelectUsersMultiple;
